<template>
  <FileGridItem
    :file="file"
    :selected="selected"
    :class="{'opaque-60': limitReached && !selected}"
    :single-item-mode="isSingleSelectMode"
    selectable
    @clicked-file="$emit('select')"
  >
    <template #after>
      <div class="flex justify-between" @click.stop>
        <q-btn
          size="12px"
          color="blue-grey"
          padding="sm"
          flat
          no-caps
          :label="isPreview ? 'Preview...' : 'View File...'"
          @click="$emit('preview')"
        />
        <q-btn
          v-if="!selected || !isSingleSelectMode"
          size="12px"
          :label="selected ? 'Remove' : (isSingleSelectMode ? 'Use' : 'Select')"
          :color="selected ? 'red-7' : 'blue-7'"
          flat
          no-caps
          padding="sm"
          @click="$emit('select')"
        />
      </div>
    </template>
  </FileGridItem>
</template>

<script>
import FileGridItem from './FileGridItem.vue'

export default {
  components: {
    FileGridItem
  },
  props: {
    file: {
      type: Object,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    limitReached: {
      type: Boolean,
      default: false
    },
    isSingleSelectMode: {
      type: Boolean,
      default: false
    },
    isPreview: {
      type: Boolean,
      default: true
    }
  },
  emits: ['select', 'preview']
}
</script>
